function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zM9 14V9h2v5H9zm1-6a1 1 0 100-2 1 1 0 000 2z",
  fill: "#FF3861"
});

var SvgBannerWarningEnable = function SvgBannerWarningEnable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMCAxMEMyMCAxNS41MjI4IDE1LjUyMjggMjAgMTAgMjBDNC40NzcxNSAyMCAwIDE1LjUyMjggMCAxMEMwIDQuNDc3MTUgNC40NzcxNSAwIDEwIDBDMTUuNTIyOCAwIDIwIDQuNDc3MTUgMjAgMTBaTTkgMTRWOUgxMVYxNEg5Wk0xMCA4QzEwLjU1MjMgOCAxMSA3LjU1MjI4IDExIDdDMTEgNi40NDc3MiAxMC41NTIzIDYgMTAgNkM5LjQ0NzcxIDYgOSA2LjQ0NzcyIDkgN0M5IDcuNTUyMjggOS40NDc3MiA4IDEwIDhaIiBmaWxsPSIjRkYzODYxIi8+Cjwvc3ZnPgo=";
export { SvgBannerWarningEnable as ReactComponent };